import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authOpen, setAuthOpen] = useState(false);
  const [authPrefill, setAuthPrefill] = useState(null); // { name, email, tab }

  const fetchMe = useCallback(async () => {
    const t = localStorage.getItem("chefhire_token");
    if (!t) { setLoading(false); return; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
    } catch {
      localStorage.removeItem("chefhire_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const setSession = (token, u) => {
    localStorage.setItem("chefhire_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("chefhire_token");
    setUser(null);
  };

  const requireAuth = (cb) => {
    if (user) { cb && cb(); return true; }
    setAuthOpen(true);
    return false;
  };

  const openAuth = (prefill = null) => {
    setAuthPrefill(prefill);
    setAuthOpen(true);
  };

  return (
    <AuthCtx.Provider value={{
      user, loading, setSession, logout, requireAuth,
      authOpen, setAuthOpen, refresh: fetchMe,
      authPrefill, setAuthPrefill, openAuth,
    }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
